import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { Flex, Form } from 'antd';
import { maxWidth } from 'config/constants';

export const StyledIssueDescription = styled(Flex)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    flex: 1;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: white;
    max-width: ${kcc.screen.CONTENT_MAX_WIDTH}px;

    ${maxWidth.m} {
      align-items: flex-start;
    }

    @media (min-width: ${kcc.screen.MD}px) and (max-width: 1024px) and (orientation: portrait) {
      align-items: flex-start;
    }

    .ant-input-data-count {
      bottom: 7px;
      right: 20px;
      font-size: ${kcc.typography.FONT_SIZE.SM}px;
    }
  `}

  .issue-description__back-btn {
    padding: 0;

    &:hover {
      background: transparent !important;
    }
  }

  ${maxWidth.m} {
    .issue-description__back-btn,
    .issue-description__next-btn {
      width: 172px;
      font-size: ${({ theme: { kcc } }): number => kcc.typography.FONT_SIZE.XL}px;
    }
  }

  .ant-btn-icon {
    line-height: 15px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const StyledIssueDescriptionFormItem = styled(Form.Item)`
  .ant-form-item-label {
    font-weight: 700;
  }

  .ant-form-item-optional {
    font-weight: 400;
  }

  .ant-form-item-explain-error {
    padding: ${({ theme: { kcc } }): number => kcc.padding.CONTENT_VERTICAL_SM}px;
  }

  label.ant-form-item-required-mark-optional {
    flex-wrap: wrap;
  }

  input::placeholder {
    color: ${({ theme: { kcc } }): string => kcc.colors.TEXT_PLACEHOLDER};
  }

  .ant-input-status-success {
    border-color: ${({ theme: { kcc } }): string => kcc.colors.TEXT};
  }

  .ant-input-textarea-show-count:not([data-count='0 / 500']) {
    border-color: ${({ theme: { kcc } }): string => kcc.colors.TEXT};
  }

  .ant-upload {
    width: 100%;
    max-width: 755px;
    cursor: pointer;

    .download-icon {
      svg {
        transform: rotate(180deg);
        width: 48px;
        height: 48px;

        path {
          fill: black;
        }
      }
    }
  }

  .ant-upload-list,
  .ant-upload-list-picture {
    width: 100%;
    max-width: 755px;

    .ant-upload-list-item-container {
      .ant-upload-list-item {
        padding: ${({ theme: { kcc } }): number => kcc.padding.CONTENT_VERTICAL_SM}px
          ${({ theme: { kcc } }): number => kcc.padding.CONTENT_HORIZONTAL_LG}px !important;

        .ant-upload-list-item-thumbnail {
          width: 40px !important;
          height: 40px !important;

          svg {
            width: 40px;
            height: 40px;

            path {
              fill: ${({ theme: { kcc } }): string => kcc.colors.TEXT};
            }
          }
        }

        .ant-upload-list-item-name {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          padding: 0 18px !important;
          font-weight: 700;
          font-size: ${({ theme }): number => theme.kcc.typography.FONT_SIZE.BASE}px;

          .ant-upload-list-item-extra {
            font-weight: 400;
          }
        }

        .ant-upload-list-item-actions {
          svg {
            width: 14px;
            height: 14px;

            path {
              fill: ${({ theme: { kcc } }): string => kcc.colors.TEXT};
            }
          }
        }
      }

      .ant-upload-list-item-uploading {
        .ant-upload-list-item-name {
          display: block;
          margin-right: 50px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .ant-upload-list-item-progress {
          padding-inline-end: 56px;

          .ant-progress-outer {
            .ant-progress-inner {
              border-radius: 0;

              .ant-progress-bg,
              .ant-progress-bg-outer {
                height: 8px !important;
                background-color: black;
                border-radius: 0;
                width: 100%;
              }
            }

            .ant-progress-text {
              position: absolute;
              bottom: 20px;
              right: 0;
              font-weight: 700;
              color: ${({ theme }): string => theme.kcc.colors.TEXT};
            }
          }
        }
      }

      .ant-upload-list-item-done {
        border-color: black !important;
      }

      .ant-upload-list-item-error {
        .ant-upload-list-item-thumbnail {
          svg {
            path {
              fill: ${({ theme: { kcc } }): string => kcc.colors.ERROR};
            }
          }
        }
      }
    }
  }

  ${maxWidth.m} {
    .warning-critical-icon {
      svg {
        width: 16px;
        height: 16px;
      }
    }
  }

  .ant-btn-icon {
    width: 22px;
    height: 22px;

    .camera-icon {
      svg {
        width: 22px;
        height: 22px;

        path {
          fill: black;
        }
      }
    }
  }
`;
